export const visit = (vm, at) => {
vm(require("foundations-components/lang/pl.lyaml"));
at({ "pl": { "placeholder": "symbol zast\u0119pczy" } });
};